import { MeetingRequestOptionsQuery, MeetingRequestOptionsQueryVariables } from '../../../types'
import { MEETING_REQUEST_OPTIONS } from '../../../graphql/requestMeetingOptions/requestMeetingOptions'
import { ApolloError, useQuery } from '@apollo/client'
import { useMeetingRequestOptionsStore } from '../../../graphql/requestMeetingOptions/MeetingRequestOptionsStore'

// Fetches requestMeetingOptions via Apollo. When store has data for this id, reads from store;
export default (
  id: number,
): {
  data: MeetingRequestOptionsQuery | undefined
  error: ApolloError | undefined
  loading: boolean
} => {
  const storeEmployeeId = useMeetingRequestOptionsStore((state) => state.employeeId)
  const storeData = useMeetingRequestOptionsStore((state) => state.data)
  const storeError = useMeetingRequestOptionsStore((state) => state.error)
  const storeLoading = useMeetingRequestOptionsStore((state) => state.loading)

  const useStore = storeEmployeeId != null && String(storeEmployeeId) === String(id)
  const queryResult = useQuery<MeetingRequestOptionsQuery, MeetingRequestOptionsQueryVariables>(MEETING_REQUEST_OPTIONS, {
    variables: { employeeId: id },
    fetchPolicy: 'network-only',
    skip: useStore,
  })

  if (useStore) {
    return {
      data: storeData ?? undefined,
      error: storeError ?? undefined,
      loading: storeLoading,
    }
  }

  return {
    data: queryResult.data,
    error: queryResult.error,
    loading: queryResult.loading,
  }
}
